export function installationServiceProvider() {
    this.$get = instantiateInstallationService;

    function instantiateInstallationService() {
        return new InstallationService(window.installation.state);
    }
}

class InstallationService {
    state: any;

    constructor(initialState) {
        this.state = initialState;
    }

    get steps() {
        return {
            welcome: 'Welcome',
            users: 'Users',
            teams: 'Teams',
            // company: 'Company',
            // 'carer-contracts': 'Carer Contracts',
            // 'client-service-contracts': 'Client Service Contracts',
            // 'booking-types': 'Booking Types',
            finish: 'Finish',
        };
    }

    get uncompletedSteps() {
        return Object.keys(this.steps).filter(step => {
            if (step === 'welcome') {
                return !this.loggedIn
                    && !this.hasToken;
            }

            if (step === 'users') {
                return !this.hasAdminUser && (this.hasToken || this.loggedInAsGhostAdmin);
            }

            if (!this.hasAdminUser || !this.loggedIn) {
                return false;
            }

            if (step === 'teams') {
                return !this.hasTeams;
            }

            // if (step === 'company') {
            //     return !this.hasCompany;
            // }
            //
            // if (step === 'carer-contracts') {
            //     return !this.hasCarerContractTypes;
            // }
            //
            // if (step === 'client-service-contracts') {
            //     return !this.hasServiceContractTypes;
            // }
            //
            // if (step === 'booking-types') {
            //     return !this.hasBookingTypes;
            // }

            if (step === 'finish') {
                return (
                    this.hasAdminUser && this.hasTeams
                    // this.hasCompany &&
                    // this.hasCarerContractTypes &&
                    // this.hasServiceContractTypes &&
                    // this.hasBookingTypes
                );
            }

            return false;
        });
    }

    get nextStep() {
        return this.uncompletedSteps[0];
    }

    get loggedIn() {
        return !!this.state.logged_in;
    }

    set loggedIn(value: boolean) {
        this.state.logged_in = value;
    }

    get loggedInAsGhostAdmin() {
        return !!this.state.logged_in_as_ghost_admin;
    }

    get hasAdminUser() {
        return !!this.state.has_admin_user;
    }

    set hasAdminUser(value) {
        this.state.has_admin_user = !!value;
    }

    get hasCarerContractTypes() {
        return !!this.state.has_carer_contract_types;
    }

    set hasCarerContractTypes(value) {
        this.state.has_carer_contract_types = !!value;
    }

    get hasServiceContractTypes() {
        return !!this.state.has_service_contract_types;
    }

    set hasServiceContractTypes(value) {
        this.state.has_service_contract_types = !!value;
    }

    get hasBookingTypes() {
        return !!this.state.has_booking_types;
    }

    set hasBookingTypes(value) {
        this.state.has_booking_types = !!value;
    }

    get hasCompany() {
        return !!this.state.has_company;
    }

    set hasCompany(value) {
        this.state.has_company = !!value;
    }

    get hasTeams() {
        return !!this.state.has_teams;
    }

    set hasTeams(value) {
        this.state.has_teams = !!value;
    }

    get token() {
        return this.state.token;
    }

    set token(value) {
        this.state.token = value;
    }

    get hasToken() {
        return !!this.state.token;
    }

    get() {
        return this.state;
    }

    allowNavigationTo(step) {
        const steps = Object.keys(this.steps);
        const nextStep = this.nextStep;

        return steps.indexOf(step) < steps.indexOf(nextStep);
    }
}
